var render, staticRenderFns
import script from "./InjectionsPerMonth.vue?vue&type=script&lang=js&"
export * from "./InjectionsPerMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a7cc12')) {
      api.createRecord('34a7cc12', component.options)
    } else {
      api.reload('34a7cc12', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/trending-charts/InjectionsPerMonth.vue"
export default component.exports